module.exports = __webpack_public_path__ + "img/index-view.45ebd2db.png";